// components/ui/combobox-simple.tsx
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

export type ComboBoxSimpleType = {
  id: number;
  name: string;
  value: string;
};

export default function ComboBoxSimple({
  items,
  label,
  value,
  onChange,
}: {
  items: ComboBoxSimpleType[];
  label?: string;
  value: string;
  onChange: (item: ComboBoxSimpleType | null) => void;
}) {
  const [query, setQuery] = useState("");
  const filteredItems =
    query === ""
      ? items
      : items.filter((item) =>
          item.name.toLowerCase().includes(query.toLowerCase())
        );

  const selectedItem = items.find((item) => item.name === value) || null;

  return (
    <Combobox
      as="div"
      value={selectedItem}
      onChange={onChange}
    >
      {/* { label && <label className="block text-sm font-medium leading-6 text-gray-900 dark:text-textDark">
        {label}
      </label>} */}
      <div className="relative mt-2">
        <ComboboxInput
          placeholder={label ? `Select ${label.toLowerCase()}...`:``}
          className="w-full rounded-md border-0 bg-gray-100/50 py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-inputBorderDark  focus:ring-1 focus:ring-inset focus:ring-inputBorderLight dark:focus:ring-inputBorderLight sm:text-sm sm:leading-6 dark:text-textDark dark:bg-inputBackgroundDark transition duration-300 ease-in-out transform focus:-translate-y-1 border-gray-300 hover:shadow-lg hover:border-blue-300  dark:bg-shadowDark"
          onChange={(event) => setQuery(event.target.value)}
          displayValue={(item: ComboBoxSimpleType | null) => item?.name || ""}
        />

        <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </ComboboxButton>

        {filteredItems.length > 0 && (
          <ComboboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white dark:bg-cardBackgroundDark py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filteredItems.map((item) => (
              <ComboboxOption
                key={item.id}
                value={item}
                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-textMutedLight dark:text-inactiveTextDark data-[focus]:bg-primary-600 data-[focus]:text-white"
              >
                <span className="block truncate group-data-[selected]:font-semibold  dark:text-inactiveTextDark group-data-[focus]:text-white">
                  {item.name}
                </span>
                <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-primary-600 group-data-[selected]:flex group-data-[focus]:text-white">
                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                </span>
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}
      </div>
    </Combobox>
  );
}